function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormgroupLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.31 22.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LOGO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "formgroup_logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.84,4V5.5h3.88V6.94H29.88V18.12h-1.7V6.94H25.92V5.5h2.26V3.94A3.48,3.48,0,0,1,32,.19a4,4,0,0,1,2.52.8l-.58,1.27a2.87,2.87,0,0,0-1.87-.63C30.6,1.63,29.84,2.45,29.84,4Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.54,11.81A6.21,6.21,0,0,1,41,5.4a6.19,6.19,0,0,1,6.41,6.41A6.21,6.21,0,0,1,41,18.24,6.23,6.23,0,0,1,34.54,11.81Zm11.11,0a4.7,4.7,0,1,0-9.38,0,4.7,4.7,0,1,0,9.38,0Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.22,5.4V7.06c-.14,0-.29,0-.41,0-2.64,0-4.25,1.68-4.25,4.66v6.43h-1.7V5.5h1.63V8C53.28,6.29,54.89,5.4,57.22,5.4Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,10.8v7.32h-1.7V11c0-2.66-1.34-4-3.62-4-2.6,0-4.23,1.68-4.23,4.56v6.62h-1.7V11c0-2.66-1.35-4-3.65-4C63.65,6.94,62,8.62,62,11.5v6.62h-1.7V5.5h1.63V7.8a5.12,5.12,0,0,1,4.64-2.4A4.52,4.52,0,0,1,71,8.07,5.51,5.51,0,0,1,76,5.4C79.11,5.4,81.12,7.18,81.12,10.8Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,5.21V16c0,4.8-2.59,7-7.25,7a10.68,10.68,0,0,1-6.34-1.77l1.49-2.69A7.77,7.77,0,0,0,90.89,20c2.64,0,3.79-1.2,3.79-3.53v-.55A5.31,5.31,0,0,1,90.6,17.5a6.14,6.14,0,0,1-6.45-6.24A6.14,6.14,0,0,1,90.6,5a5.2,5.2,0,0,1,4.28,1.85V5.21Zm-3.7,6.05a3.4,3.4,0,1,0-3.38,3.17A3.14,3.14,0,0,0,94.73,11.26Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.92,5V8.47c-.31,0-.55,0-.84,0-2.06,0-3.43,1.12-3.43,3.6v6.09h-3.74V5.21h3.57v1.7A5.24,5.24,0,0,1,109.92,5Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,11.67c0-3.89,3-6.65,7.11-6.65s7.08,2.76,7.08,6.65-3,6.64-7.08,6.64S111.07,15.55,111.07,11.67Zm10.4,0a3.31,3.31,0,1,0-6.6,0,3.31,3.31,0,1,0,6.6,0Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.76,5.21V18.12h-3.55V16.59a5.23,5.23,0,0,1-4,1.72c-3.24,0-5.52-1.82-5.52-5.8V5.21h3.75V12c0,2.16,1,3.12,2.61,3.12s3-1.1,3-3.48V5.21Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.31,11.67a6.27,6.27,0,0,1-6.44,6.64A5,5,0,0,1,148,16.75v6h-3.75V5.21h3.58V6.7A5,5,0,0,1,151.87,5,6.27,6.27,0,0,1,158.31,11.67Zm-3.8,0a3.3,3.3,0,1,0-6.57,0,3.3,3.3,0,1,0,6.57,0Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,22.89l-.19-.1V6.51L3,6.4,5.73,8l.06.11v9.66l13.91-8,.19.11v3.2l-.06.11ZM3,6.73V22.57L19.64,13V10.06l-13.91,8L5.54,18V8.18Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73,18.09,5.54,18v-3.2l.07-.11L14,9.85.06,1.82V1.6L2.83,0H3L19.83,9.74V10Zm.06-3.23v2.91L19.51,9.85,2.9.25.38,1.71l13.9,8V10Z",
    style: {
      fill: "#080c0a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83,22.89.06,21.29,0,21.18V1.71L.19,1.6,14.28,9.74V10l-2.77,1.59h-.12L3,6.73V22.79ZM.25,21.11l2.52,1.46V6.51L3,6.4l8.49,4.9L14,9.85.25,1.92Z",
    style: {
      fill: "#080c0a"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormgroupLogoBlack);
export default __webpack_public_path__ + "static/media/formgroupLogoBlack.79b5ce9c2c9be44db3488ec2b7ea11b8.svg";
export { ForwardRef as ReactComponent };